import React from "react"

import { EnumCell } from "app/static/frontend/sheets/components/cells/MantineCells/EnumCell"

export const MembershipCell = (props) => (
    <EnumCell {...props} field={DjangIO.app.committee.models.CommitteeMember._meta.get_field("role")} />
)
